import { Controller } from "@hotwired/stimulus"

// Opens the first reel card in the moments section on connect.
// Delegates all player logic to the moment-card controller.
export default class extends Controller {
  connect() {
    const firstCard = this.element.querySelector('[data-controller~="moment-card"]')
    if (!firstCard) return

    // Child moment-card controllers may not be connected yet — wait one frame.
    // If the first card was server-rendered active, open() becomes a no-op.
    requestAnimationFrame(() => {
      const ctrl = this.application.getControllerForElementAndIdentifier(firstCard, "moment-card")
      if (ctrl) ctrl.open()
    })
  }
}
